
import NotificationContent from "./NotificationContent";

const NotificationTracker: React.FC = () => {
    return (
        <div className="container-fluid mt-2">
            <div className="row">
                <div className="col-sm-12">
                    <div className="main-container">
                        <div className="main-container-inner">
                            <div className="main-card revrex-data-table-card">
                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    <h1 className='page-title-sm'>Notifications Tracker</h1>
                                </div>
                                <NotificationContent />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationTracker;